export default __webpack_public_path__ + "img/eAFNwDHv.b4d66133.svg";